// extracted by mini-css-extract-plugin
module.exports = {"categories__wrapper":"N_dn","categories__list":"N_dp"};